"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StackingComponentHOC = exports.StackingComponentWrapper = exports.StackingRootContext = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var ReactDOM = tslib_1.__importStar(require("react-dom"));
var Declarative_1 = require("./Declarative");
var PortalEventTrap_1 = require("./PortalEventTrap");
var ReactHelpers_1 = require("./ReactHelpers");
/**
 * The stacking root is the element container into which the mount point for Portals will be appended.
 */
exports.StackingRootContext = React.createContext(null);
exports.StackingRootContext.displayName = 'StackingRootContext';
function getStackingRootElement(stackingRootId, context) {
    var stackingRoot = document.getElementById(stackingRootId) || context || document.body;
    if (!stackingRoot) {
        throw new Error('Could not find stacking root.');
    }
    return stackingRoot;
}
var StackingComponentWrapper = /** @class */ (function (_super) {
    tslib_1.__extends(StackingComponentWrapper, _super);
    function StackingComponentWrapper(props, context) {
        var _this = _super.call(this, props) || this;
        // tslint:disable-next-line:deprecation
        var stackingRootId = props.stackingRootId;
        if (stackingRootId) {
            console.warn('`stackingRootId` is deprecated and no longer necessary for the vast majority of cases.');
        }
        _this.stackingRoot = getStackingRootElement(stackingRootId, context);
        /*
         * Create the mount point where the stacked element will be mounted and append it to the stacking root.  It should align
         * with the top/left of the stacking root as to align the positioning of stacked elements with the stacking root.  This prevents
         * cases where there are relatively positioned elements above the mount point, thus making the top of the mount point below the top
         * of the stacking root.
         */
        _this.mountPoint = document.createElement('div');
        _this.mountPoint.style.position = 'absolute';
        _this.mountPoint.style.top = '0';
        _this.mountPoint.style.left = '0';
        _this.updateMountPoint();
        return _this;
    }
    StackingComponentWrapper.prototype.componentDidMount = function () {
        this.stackingRoot.appendChild(this.mountPoint);
    };
    StackingComponentWrapper.prototype.componentDidUpdate = function (prevProps) {
        // tslint:disable-next-line:deprecation
        var _a = this.props, stackingRootId = _a.stackingRootId, wrapperTestId = _a.wrapperTestId, zIndex = _a.zIndex;
        var stackingRoot = getStackingRootElement(stackingRootId, this.context);
        if (stackingRoot !== this.stackingRoot) {
            this.stackingRoot = stackingRoot;
            this.stackingRoot.appendChild(this.mountPoint);
        }
        if (wrapperTestId !== prevProps.wrapperTestId || zIndex !== prevProps.zIndex) {
            this.updateMountPoint();
        }
    };
    StackingComponentWrapper.prototype.componentWillUnmount = function () {
        this.stackingRoot.removeChild(this.mountPoint);
    };
    StackingComponentWrapper.prototype.getMountPoint = function () {
        return this.mountPoint;
    };
    StackingComponentWrapper.prototype.getStackingRoot = function () {
        return this.stackingRoot;
    };
    StackingComponentWrapper.prototype.updateMountPoint = function () {
        this.mountPoint.style.zIndex = "" + this.props.zIndex;
        this.mountPoint.setAttribute('data-tb-test-id', Declarative_1.makeTestId(this.props.wrapperTestId, 'Root'));
    };
    StackingComponentWrapper.prototype.render = function () {
        return ReactDOM.createPortal(React.createElement(exports.StackingRootContext.Provider, { value: this.mountPoint },
            React.createElement(PortalEventTrap_1.PortalEventTrap, tslib_1.__assign({}, this.props.portalEventTrapOverrides, { children: this.props.children }))), this.mountPoint);
    };
    return StackingComponentWrapper;
}(React.Component));
exports.StackingComponentWrapper = StackingComponentWrapper;
StackingComponentWrapper.contextType = exports.StackingRootContext;
exports.StackingComponentHOC = function (componentType) {
    var componentClass = ReactHelpers_1.convertToStatefulComponentClass(componentType);
    var newComponentClass = /** @class */ (function (_super) {
        tslib_1.__extends(class_1, _super);
        function class_1() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        class_1.prototype.render = function () {
            return React.createElement(StackingComponentWrapper, tslib_1.__assign({}, this.props, { children: _super.prototype.render.call(this) }));
        };
        return class_1;
    }(componentClass));
    newComponentClass.displayName = "StackingComponentHOC(" + ReactHelpers_1.getComponentName(componentType) + ")";
    return newComponentClass;
};
//# sourceMappingURL=StackingComponent.js.map